'use client';

import DictionaryGrid from '@/app/[locale]/(learning)/glossary/_component/DictionaryGrid';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import useResizeObserver from '@/hooks/useResizeObserver';
import { useState } from 'react';
import AlphabeticHeader from './AlphabeticHeader';
import DictionaryGroups from './DictionaryGroups';
import DictionaryProvider from './DictionaryProvider';
import Pagination from './Pagination';
import SearchForm from './SearchForm';

export default function Dictionary({ data = {}, params = {}, entries = [], languages = [] }) {
  const [ref, size] = useResizeObserver();

  const { tagline, title, description, searchForm, instruction } = data;
  const { locale } = params;

  const localeWithoutEU = locale.replace('-EU', '');
  const collator = new Intl.Collator(localeWithoutEU);
  const letters = entries.map(([key]) => key.toLocaleUpperCase(localeWithoutEU)).sort(collator.compare);

  const isLatinOnly = languages.some(lang => lang.code === locale && lang.onlyLatinChars);

  return (
    <section className='glossary-dictionary bg-white text-background'>
      <div className='container'>
        {tagline && (
          <div
            className='h4 font-normal leading-relaxed max-w-md mb-[var(--section-py)] text-center mx-auto prose'
            dangerouslySetInnerHTML={{ __html: tagline }}
          />
        )}
        <div className='flex flex-col gap-6 text-center items-center mb-8'>
          {title && <h2>{title}</h2>}
          {description && (
            <div className='max-w-screen-lg link-secondary prose' dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </div>

        <DictionaryProvider errorMessages={searchForm?.errorMessages} entries={entries}>
          <SearchForm {...searchForm} />

          <AlphabeticHeader
            letters={letters}
            instruction={instruction}
            entries={entries}
            isLatinOnly={isLatinOnly}
            ref={ref}
          />

          {isLatinOnly && (
            <DictionaryGroups entries={entries.sort(collator.compare)} isLatinOnly={isLatinOnly} headerSize={size} />
          )}

          {!isLatinOnly && <DictionaryGrid />}
        </DictionaryProvider>
      </div>
    </section>
  );
}
